// :cow: Cosmose CONFIDENTIAL :iso:
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, STATE_NAME_SELECT_VIDEO_CREATOR } from './select-video-creator.reducer';

const currentState = createFeatureSelector<State>(STATE_NAME_SELECT_VIDEO_CREATOR);

export const selectVideoCreatorListResponse = createSelector(
  currentState,
  (state: State) => state.response,
);

export const selectVideoCreatorListError = createSelector(
  currentState,
  (state: State) => state.responseError,
);

export const selectVideoCreatorListShowSkeleton = createSelector(
  currentState,
  (state: State) => state.responseLoading,
);


